export const environment = {
  production: true,
  youtubeClientId:
    "458340445465-acoedftrhhqtj80phmelq8pfco00laba.apps.googleusercontent.com",
};
